import { useState } from 'react';
import { collection, addDoc } from 'firebase/firestore';
import { db, storage } from "../../Firebase/firebaseConfig/firebase";
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

export default function Crear() {

    const productosCollection = collection(db, "Productos");
    const navigate = useNavigate();

    const [form, setForm] = useState({
        Nombre: "",
        Precio: "",
        Descripcion: "",
        Contenido: "",
        Imagen: "",
        Alcoholica: "",

    });

    const cambio = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value
        });
    };

    const create = async (e) => {
        e.preventDefault();
        alertaCreacion();
        const data = {
            Nombre: form.Nombre,
            Alcoholica: form.Alcoholica,
            Descripcion: form.Descripcion,
            Precio: form.Precio,
            Contenido: form.Contenido,
            Imagen: form.Imagen,
        };
        await addDoc(productosCollection, data);
        navigate("/productos");
    }

    const alertaCreacion = () => {
        Swal.fire({
            title: 'Producto nuevo creado',
            showClass: {
                popup: 'animate__animated animate__fadeInDown'
            },
            hideClass: {
                popup: 'animate__animated animate__fadeOutUp'
            }
        });
    }

    async function subirImagen(e) {
        //Detectar el archivo
        const archivoImg = e.target.files[0]
        const refarchivo = ref(storage, `Productos/imagenes/${archivoImg.name}`)
        await uploadBytes(refarchivo, archivoImg)
        form.Imagen = await getDownloadURL(refarchivo)
    }

    return (
        <>
            <div className='productos-form container bg-dark text-center'>
                <h1 className='mt-3 text-light mx-auto'>Crear producto</h1>

                <form onSubmit={create} className="mt-5">
                    <div className='row'>
                        <div className='col-8 input-group mb-3'>
                            <span class="input-group-text">Nombre</span>
                            <input
                                name='Nombre'
                                value={form.Nombre}
                                type="text"
                                required
                                className='form-control w-50'
                                onChange={cambio}
                            />
                        </div>
                    </div>

                    <div className='col-4 input-group mb-3'>
                        <span class="input-group-text">¿Alcohólica?</span>
                        <input
                            name='Alcoholica'
                            id='Alcoholica'
                            class="form-check-input m-3"
                            onChange={e => form.Alcoholica = e.target.checked}
                            type="checkbox"
                            unchecked
                        />
                    </div>

                    <div className='row'>
                        <div className='col input-group mb-3'>
                            <span class="input-group-text">Descripción</span>
                            <textarea
                                name='Descripcion'
                                value={form.Descripcion}
                                type="text"
                                className='form-control w-50 m-auto'
                                onChange={cambio}
                            ></textarea>
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col'>
                            <div class="input-group mb-3">
                                <span class="input-group-text">Precio</span>
                                <span class="input-group-text">$</span>
                                <input
                                    name='Precio'
                                    type="number"
                                    class="form-control "
                                    value={form.Precio}
                                    required
                                    onChange={cambio}
                                />
                                <span class="input-group-text">.00</span>
                            </div>
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col input-group mb-3'>
                            <span class="input-group-text">Contenido</span>
                            <input
                                name="Contenido"
                                value={form.Contenido}
                                type="text"
                                required
                                className='form-control w-50 m-auto'
                                onChange={cambio}
                            />
                            <span class="input-group-text">(l/ml)</span>
                        </div>
                    </div >
                    <div className='row'>
                        <div className='col input-group mb-3'>
                            <span class="input-group-text">Subir Imagen</span>
                            <input
                                type="file"
                                id='file'
                                required
                                className='form-control w-50 m-auto'
                                onChange={subirImagen}

                            />
                        </div>
                    </div >

                    <button onClick={create} type="submit" className='producto-btn btn btn-outline-light btn-lg my-4'>Guardar</button>

                </form >
            </div >
        </>
    )
}